<template>
  <div class="share-button-wrapper">
    <transition name="slide">
      <div
        v-if="isOpened"
        class="buttons-list"
      >
        <a
          :href="`https://twitter.com/intent/tweet?text=${text}&hashtags=${hashtags}&url=${pageUrl}`"
          target="_blank"
          title="Share by Twitter"
          rel="noopener"
        >
          <TwitterIcon />
        </a>
        <a
          :href="`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`"
          target="_blank"
          title="Share by Facebook"
          rel="noopener"
        >
          <FacebookIcon />
        </a>
        <a
          :href="`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`"
          target="_blank"
          title="Share by LinkedIn"
          rel="noopener"
        >
          <LinkedinIcon />
        </a>
        <a
          :href="`mailto:?body=${pageUrl}`"
          target="_blank"
          title="Share by Email"
          rel="noopener"
        >
          <MailIcon />
        </a>
      </div>
    </transition>
    <button
      class="share-button"
      aria-label="Share button"
      @click="isOpened = !isOpened"
    >
      <transition name="morph">
        <ShareIcon v-if="!isOpened" />
        <LongArrowDownIcon
          v-else
          class="arrow"
        />
      </transition>
    </button>
  </div>
</template>

<script>
import ShareIcon from '~/components/Common/Svg/ShareIconV2';
import MailIcon from '~/components/Common/Svg/MailIcon';
import FacebookIcon from '~/components/Common/Svg/FacebookIcon';
import TwitterIcon from '~/components/Common/Svg/TwitterIcon';
import LinkedinIcon from '~/components/Common/Svg/LinkedinIcon';
import LongArrowDownIcon from '~/components/Common/Svg/LongArrowDownIcon';

export default {
  components: {
    ShareIcon,
    TwitterIcon,
    FacebookIcon,
    MailIcon,
    LinkedinIcon,
    LongArrowDownIcon,
  },

  props: {
    hashtags: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isOpened: false,
    };
  },

  computed: {
    pageUrl() {
      return this.url || `${process.env.hostUrl}${this.$route.path}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ShareButton.scss';
</style>
